import { render, staticRenderFns } from "./StatisticsCommerce.vue?vue&type=template&id=39bfea80&"
import script from "./StatisticsCommerce.vue?vue&type=script&lang=js&"
export * from "./StatisticsCommerce.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCommerce.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
